"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solidlyStable_getLiquidatableXPriceDecrease = exports.solidlyStable_getXInMargin = exports.solidlyStable_getEquityValue = exports.solidlyStable_yOut = exports.solidlyStable_k = exports.solidlyStable_getPriceFromReserves = exports.uniswapV2_getLiquidatableXPriceDecrease = exports.uniswapV2_getPriceFromReserves = void 0;
/**
 * Calculate X/Y price
 */
function uniswapV2_getPriceFromReserves(x, y, priceInverted = false) {
    const price = y / x;
    return !priceInverted ? price : 1 / price;
}
exports.uniswapV2_getPriceFromReserves = uniswapV2_getPriceFromReserves;
/**
 * Find liquidation threshold given X/Y price decrease
 * Returns a price ratio in the [0,1] range
 *  - 0 meaning it will never get liquidated
 *  - 1 meaning it is liquidatable
 */
function uniswapV2_getLiquidatableXPriceDecrease(x0, y0, debtX, debtY) {
    if (debtX == 0 && debtY == 0)
        return 0;
    if (x0 == 0 || y0 == 0)
        return 1;
    const k = x0 * y0;
    const x = k / debtY * (1 + Math.sqrt(1 - debtY * debtX / k));
    if (!x)
        return 1;
    if (x <= x0)
        return 1;
    if (x == Infinity)
        return 0;
    const y = k / x;
    const price0 = uniswapV2_getPriceFromReserves(x0, y0);
    const price = uniswapV2_getPriceFromReserves(x, y);
    if (price >= price0)
        return 1;
    return price / price0;
}
exports.uniswapV2_getLiquidatableXPriceDecrease = uniswapV2_getLiquidatableXPriceDecrease;
/**
 * Calculate X/Y price
 */
function solidlyStable_getPriceFromReserves(x, y, priceInverted = false) {
    const N = 3 * Math.pow(x, 2) * y + Math.pow(y, 3);
    const D = 3 * Math.pow(y, 2) * x + Math.pow(x, 3);
    const price = N / D;
    return !priceInverted ? price : 1 / price;
}
exports.solidlyStable_getPriceFromReserves = solidlyStable_getPriceFromReserves;
function solidlyStable_k(x, y) {
    return Math.pow(x, 3) * y + Math.pow(y, 3) * x;
}
exports.solidlyStable_k = solidlyStable_k;
/**
 * Calculate output from reserves y given input from x
 */
function solidlyStable_yOut(xIn, x0, y0) {
    const k0 = solidlyStable_k(x0, y0);
    const x = x0 + xIn;
    let y = y0;
    // search for new y
    for (let i = 0; i < 16; i++) {
        const yPrev = y;
        const k = solidlyStable_k(x, y);
        const d = 3 * x * Math.pow(y, 2) + Math.pow(x, 3);
        if (k < k0) {
            const dy = (k0 - k) / d;
            y = y + dy;
        }
        else {
            const dy = (k - k0) / d;
            y = y - dy;
        }
        if (Math.abs((y - yPrev) / y) < 1e-10) {
            break;
        }
    }
    return y0 - y;
}
exports.solidlyStable_yOut = solidlyStable_yOut;
function solidlyStable_getEquityValue(x, y, debtX, debtY) {
    if ((x == 0 || y == 0) && (debtX > 0 || debtY > 0))
        return -Infinity;
    const price = solidlyStable_getPriceFromReserves(x, y);
    const lpValue = x * price + y;
    const debtValue = debtX * price + debtY;
    return lpValue - debtValue;
}
exports.solidlyStable_getEquityValue = solidlyStable_getEquityValue;
/**
 * Find xIn input amount that would bring the equity to negative
 */
function solidlyStable_getXInMargin(x0, y0, debtX, debtY) {
    if (debtX == 0 && debtY == 0)
        return Infinity;
    if (x0 == 0 || y0 == 0)
        return 0;
    if (solidlyStable_getEquityValue(x0, y0, debtX, debtY) < 0)
        return 0;
    const STARTING_POINT = x0 * 1e9;
    let xIn = STARTING_POINT;
    let xInPrev = 0;
    // binary search for xIn
    for (let i = 0; i < 1000; i++) {
        const x = x0 + xIn;
        const y = y0 - solidlyStable_yOut(xIn, x0, y0);
        const jump = Math.abs(xIn - xInPrev) / 2;
        if (Math.abs(jump / x0) < 1e-10)
            break;
        xInPrev = xIn;
        if (solidlyStable_getEquityValue(x, y, debtX, debtY) < 0)
            xIn -= jump;
        else {
            if (xIn == STARTING_POINT)
                return Infinity;
            xIn += jump;
        }
    }
    return xIn;
}
exports.solidlyStable_getXInMargin = solidlyStable_getXInMargin;
/**
 * Find liquidation threshold given X/Y price decrease
 * Returns a price ratio in the [0,1] range
 */
function solidlyStable_getLiquidatableXPriceDecrease(x0, y0, debtX, debtY) {
    const xIn = solidlyStable_getXInMargin(x0, y0, debtX, debtY);
    if (xIn == 0)
        return 1;
    if (xIn == Infinity)
        return 0;
    const x = x0 + xIn;
    const y = y0 - solidlyStable_yOut(xIn, x0, y0);
    const price0 = solidlyStable_getPriceFromReserves(x0, y0);
    const price = solidlyStable_getPriceFromReserves(x, y);
    if (price >= price0)
        return 1;
    return price / price0;
}
exports.solidlyStable_getLiquidatableXPriceDecrease = solidlyStable_getLiquidatableXPriceDecrease;
